export const useStyles = theme => ({
  draftRoot: {
    padding: '2em 5em',
    backgroundColor: '#0D6A41',
    height: '100vh',
    [theme.breakpoints.down('sm')]: {
      padding: '1em',
    },
    overflow: 'auto',
  },
  lbContainer: {
    alignItems: 'baseline',
  },
  boardContainer: {
    marginTop: '3%',
  },
  leaderBoard: {
    marginTop: '40px',
    width: '900px',
    borderSpacing: 0,
    overflowX: 'auto',
    '@media (max-width: 899px)': {
      width: '90vw',
    },
  },
  lbTab: {
    position: 'relative',
  },
  tabText: {
    backgroundColor: '#fff',
    color: '#0D6A41',
    font: 'normal normal 900 30px Maax-Black',
    border: '3px solid #fff',
    padding: '10px',
  },
  tabLeft: {
    backgroundColor: '#fff',
    color: '#0D6A41',
    border: '3px solid #fff',
    borderTopLeftRadius: '15px',
    padding: '10px',
    textAlign: 'left',
  },
  tabRight: {
    backgroundColor: '#fff',
    color: '#0D6A41',
    border: '3px solid #fff',
    borderTopRightRadius: '15px',
    padding: '10px',
    textAlign: 'right',
  },
  lbHeader: {
    backgroundColor: '#0D6A41',
    borderStyle: 'solid',
    borderColor: '#fff',
  },
  lbTitle: {
    color: '#E9AB00',
    font: 'normal normal 900 80px Maax-Black',
    '@media (max-width: 760px)': {
      font: 'normal normal 900 20px Maax-Black',
    },
  },
  lbSmall: {
    color: '#fff',
    font: 'normal normal 20px Maax-Black',
  },
  rosterText: {
    color: '#E9AB00',
    font: 'normal normal 12px Maax-Italic',
    cursor: 'pointer',
  },
  tabName: {
    font: 'normal normal 30px Maax-Black',
    color: '#0D6A41',
  },
  tableHead: {
    color: '#FFFFFF',
    font: 'normal normal 18px Maax-Bold',
    borderBottom: '3px solid #fff',
    padding: '10px 10px 10px 20px',
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  tableHeadLeft: {
    color: '#fff',
    font: 'normal normal 18px Maax-Bold',
    borderLeft: '3px solid #fff',
    borderBottom: '3px solid #fff',
    borderBottomLeftRadius: '15px',
    padding: '10px 20px 10px 20px',
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  tableHeadRight: {
    color: '#fff',
    font: 'normal normal 18px Maax-Bold',
    borderRight: '3px solid #fff',
    borderBottom: '3px solid #fff',
    borderBottomRightRadius: '15px',
    padding: '10px',
    verticalAlign: 'middle',
  },
  tableBody: {
    padding: '10px',
  },
  tableBodyCenter: {
    font: 'normal normal 20px Maax-Bold',
    color: '#fff',
    padding: '20px',
    borderBottom: '1px solid #fff',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  tableBodyLeft: {
    font: 'normal normal 20px Maax-Bold',
    color: '#fff',
    padding: '20px',
    borderBottom: '1px solid #fff',
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  tableBodyText: {
    font: 'normal normal 20px Maax-Bold',
    color: '#fff',
    paddingTop: '20px',
    paddingBottom: '20px',
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  tablePage: {
    borderBottom: 'none',
    font: 'normal normal 20px Maax',
    color: '#fff',
    position: 'relative',
    paddingTop: '30px',
  },
  pageLeft: {
    position: 'absolute',
    left: 0,
    color: '#fff',
  },
  pageRight: {
    position: 'absolute',
    right: 0,
    color: '#fff',
  },
  dlTitle: {
    font: 'normal normal 30px Maax-Black',
    color: '#0D6A41',
    textAlign: 'center',
    margin: '20px',
  },
  dlScore: {
    font: 'normal normal 53px Maax-Black',
    color: '#E9AB00',
    textAlign: 'center',
    margin: '20px',
  },
  dlTable: {
    backgroundColor: '#fff',
    '@media (max-width: 760px)': {
      minWidth: '300px',
    },
  },
  dlHead: {
    backgroundColor: '#fff',
    '& th': {
      backgroundColor: '#fff',
    }
  },
  dlLabel: {
    color: '#0D6A41',
    font: 'normal normal 22px Maax-Black',
    borderBottom: 'none',
  },
  dlCell: {
    color: '#0D6A41',
    font: 'normal normal 22px Montserrat',
    borderBottom: 'none',
  },
  dlOpaque: {
    color: '#0D6A41',
    font: 'normal normal 22px Montserrat',
    borderBottom: 'none',
    opacity: 0.2,
  },
  dlButton: {
    color: '#fff',
    backgroundColor: '#0D6A41',
    font: 'normal normal 700 20px Maax-Black',
    borderRadius: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '20px',
    paddingRight: '20px',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#0D6A41',
    }
  },
  landingTitle: {
    font: 'normal normal 900 98px Maax-Black',
    color: '#fff',
    marginTop: '120px',
  },
  landingSecond: {
    font: 'normal normal 900 50px Maax-Black',
    color: '#F0B310',
    marginBottom: '20px',
  },
  landingButton: {
    color: '#0D6A41',
    font: 'normal normal 20px Maax-Black',
    width: '350px',
    height: '100px',
    padding: '10px',
    borderRadius: '10px',
    textAlign: 'center',
    borderColor: '#B4C64C',
    backgroundColor: '#B4C64C',
    '&:hover': {
      backgroundColor: '#0D6A41',
      color: '#B4C64C',
    },
  },
});
